/**
 * IconLoader - Utility class to manage SVG icons
 */
export class IconLoader {
  private static iconCache: Map<string, string> = new Map();
  
  /**
   * Load an SVG icon by name
   */
  public static async loadIcon(name: string): Promise<string> {
    // Check if icon is already cached
    if (this.iconCache.has(name)) {
      return this.iconCache.get(name)!;
    }
    
    try {
      // Load the SVG file
      const response = await fetch(`./assets/ui/icons/${name}.svg`);
      const svgContent = await response.text();
      
      // Cache the SVG content
      this.iconCache.set(name, svgContent);
      
      return svgContent;
    } catch (error) {
      console.error(`Failed to load icon: ${name}`, error);
      return '';
    }
  }
  
  /**
   * Get a hardcoded icon by name (fallback for when fetching fails)
   */
  public static getIcon(name: string): string {
    switch (name) {
      case 'fullscreen':
        return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 3.75V8.25M3.75 3.75H8.25M3.75 3.75L9 9M3.75 20.25V15.75M3.75 20.25H8.25M3.75 20.25L9 15M20.25 3.75L15.75 3.75M20.25 3.75V8.25M20.25 3.75L15 9M20.25 20.25H15.75M20.25 20.25V15.75M20.25 20.25L15 15" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      case 'minimize':
        return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 9L9 4.5M9 9L4.5 9M9 9L3.75 3.75M9 15L9 19.5M9 15L4.5 15M9 15L3.75 20.25M15 9H19.5M15 9V4.5M15 9L20.25 3.75M15 15H19.5M15 15L15 19.5M15 15L20.25 20.25" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      case 'arrow-left':
        return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 19.5L3 12M3 12L10.5 4.5M3 12H21" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      default:
        return '';
    }
  }
} 